const STRIPE_TEST_ENVIRONMENT_ACCOUNTS = [
  1, // Demo Account
  18012, // TeamBuildr Fitness & Strength
];

/**
 * Helper func to return the Stripe Test key or Live key for a given account code
 * @param {Number} accountCode the account code to check against
 * @returns {String | null} The Stripe Test or Live API Key
 */
export const getTestOrLiveStripeApiKey = (accountCode) => {
  if (
    STRIPE_TEST_ENVIRONMENT_ACCOUNTS.includes(accountCode)
  ) {
    return process.env.STRIPE_PUBLIC_KEY_TEST;
  }
  return process.env.STRIPE_PUBLIC_KEY;
};
